/**
 * Meta etiketleri için uzunluk yardımcıları.
 * Google başlıkları ~60, açıklamaları ~160 karakterde kesiyor.
 */

/**
 * Açıklamayı 120–165 aralığına getirir.
 * Uzunsa kelime sınırından kırpar; kısaysa verilen tamamlayıcıyı ekler.
 */
export const clampDescription = (text: string, fallbackSuffix = ''): string => {
  const MAX = 160
  const MIN = 120
  let out = text.replace(/\s+/g, ' ').trim()

  if (out.length < MIN && fallbackSuffix) {
    out = `${out} ${fallbackSuffix}`.trim()
  }
  if (out.length <= MAX) return out

  const cut = out.slice(0, MAX - 1)
  const lastSpace = cut.lastIndexOf(' ')
  return `${(lastSpace > MIN ? cut.slice(0, lastSpace) : cut).replace(/[,;:.\s]+$/, '')}…`
}

/**
 * Başlığı kısaltır. Uzun başlıklarda iki noktadan sonraki açıklama kısmı
 * ("...: Teşhisi, Tedavisi ve Sebepleri") atılır, ana ifade korunur.
 */
export const shortenTitle = (title: string, max = 42): string => {
  if (title.length <= max) return title

  // Önce ":" sonrasını at — anahtar kelime baştaki kısımdadır.
  const colon = title.indexOf(':')
  if (colon > 0 && colon <= max) return title.slice(0, colon).trim()

  const cut = title.slice(0, max)
  const lastSpace = cut.lastIndexOf(' ')
  return lastSpace > 0 ? cut.slice(0, lastSpace).trim() : cut.trim()
}
